module.exports = __webpack_public_path__ + "img/icon_sheep_download_code.dfb109dc.png";